import React from "react";
import { Timer, User, Tag,  } from "lucide-react";
import logo from '../assets/images/h5.gif'
import logo1 from '../assets/images/herb4.jpg'
import logo2 from '../assets/images/herb5.jpg'
import logo3 from '../assets/images/herb7.jpg'

const BLOG_POSTS = [
  {
    title: "BioSurge: Daily Herbal Wellness Support",
    author: "BioSurge Wellness",
    date: "Trusted Daily Routine",
    image: logo1,
    excerpt:
      "BioSurge is a traditional herbal wellness blend crafted to support daily energy, reduce tiredness, and help you stay active and balanced throughout your routine.",
    category: "Herbal Wellness",
    link: "#biosurge-power",
  },
  {
    title: "Traditional Nourishment for an Active Lifestyle",
    author: "BioSurge Formula",
    date: "Routine Care",
    image: logo2,
    excerpt:
      "Made with time-tested herbal ingredients, this nourishing blend complements your daily routine and helps maintain overall wellbeing for a more active and refreshed lifestyle.",
    category: "Daily Support",
    link: "#stamina-performance",
  },
  {
    title: "Balanced Living with Herbal Care",
    author: "BioSurge Care",
    date: "Lifestyle Wellness",
    image: logo3,
    excerpt:
      "BioSurge supports general wellness by helping maintain natural energy levels and promoting a balanced lifestyle with its honey-based herbal formulation.",
    category: "Overall Wellness",
    link: "#complete-health",
  },
];


const BlogPostCard = ({ post }) => (
  <div
    style={{
      backgroundColor:'black',
      // borderRadius: "16px",
      // boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
      overflow: "hidden",
      color: 'whitesmoke !important',
      // transition: "all 0.4s ease",
      //  border: "1px solid whitesmoke",
     
      borderRadius: "16px",
    boxShadow: "0 4px 20px rgb(26 201 66 / 33%)",
  transition: "all 0.2s ease-in-out",
   padding: "0.8rem 1rem",
    }}
  >
    <a href={post.link} style={{ display: "block" }}>
      <img
        src={post.image}
        alt={post.title}
        style={{
          width: "100%",
          height: "200px",
          objectFit: "cover",
          transition: "opacity 0.3s",
        }}
        onError={(e) => {
          e.target.onerror = null;
          e.target.src =
            "https://placehold.co/400x300/a0522d/FFFFFF?text=Dry+Fruit+Blog";
        }}
      />
    </a>

    <div style={{ padding: "24px" }}>
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          padding: "6px 12px",
          fontSize: "12px",
          fontWeight: "600",
          borderRadius: "9999px",
          backgroundColor: 'black',
          color: "#fff",
          marginBottom: "12px",
        }}
      >
        <Tag size={14} style={{ marginRight: "4px" }} /> {post.category}
      </span>

      <h3
        style={{
          fontSize: "20px",
          fontWeight: "700",
          color: "whitesmoke",
          marginBottom: "10px",
          cursor: "pointer",
        }}
      >
        <a href={post.link} style={{ textDecoration: "none", color: "inherit" }}>
          {post.title}
        </a>
      </h3>

      <p style={{ color: "whitesmoke", marginBottom: "16px", fontSize: "14px" }}>
        {post.excerpt}
      </p>

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          borderTop: "1px solid #e5e7eb",
          paddingTop: "10px",
          fontSize: "12px",
          color: "#6b7280",
        }}
      >
        <span style={{ display: "flex", alignItems: "center" }}>
          <User size={14} color="whitesmoke" style={{ marginRight: "4px" }} /> by{" "}
          {post.author}
        </span>
        <span style={{ display: "flex", alignItems: "center" }}>
          <Timer size={14} color="whitesmoke" style={{ marginRight: "4px" }} />{" "}
          {post.date}
        </span>
      </div>
    </div>
  </div>
);

const Blog = () => {
  return (
    <div
      style={{
        fontFamily: "sans-serif",
        backgroundColor: 'black',
        minHeight: "100vh",
      }}
    >
      {/* HERO SECTION */}
     <header
  style={{
    backgroundImage: `url(${logo})`, 
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    color: 'whitesmoke',
    backgroundColor: 'black',
    padding: "100px 20px",
    textAlign: "center",
    boxShadow: "0 6px 20px rgba(0, 0, 0, 0.66)",
    position: "relative",
    overflow: "hidden",
  }}
>
  {/* Overlay for better text contrast */}
  <div
    style={{
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
     
      borderBottomLeftRadius: "40px",
      borderBottomRightRadius: "40px",
      zIndex: 1,
    }}
  ></div>

<div style={{ position: "relative", zIndex: 2 }}>
  <h1
    style={{
      fontSize: "56px",
      fontWeight: "800",
      marginBottom: "16px",
      color: "whitesmoke",
    }}
  >
    BioSurge Wellness Journal
  </h1>

  <p
    style={{
      color: "whitesmoke",
      fontSize: "20px",
      maxWidth: "720px",
      margin: "0 auto",
      lineHeight: "1.7",
    }}
  >
    Honest conversations on everyday wellness — from boosting natural energy and
    easing fatigue to building better habits that keep you active, balanced, and
    mentally strong. A space dedicated to practical insights, mindful living,
    and long-term wellbeing.
  </p>
</div>

</header>


      {/* BLOG POSTS */}
      <section style={{ padding: "80px 20px" }}>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
            gap: "40px",
            maxWidth: "1200px",
            margin: "0 auto",
          }}
        >
          {BLOG_POSTS.map((post, index) => (
            <BlogPostCard key={index} post={post} />
          ))}
        </div>

        <div style={{ textAlign: "center", marginTop: "60px" }}>
          {/* <button
            style={{
              padding: "12px 28px",
              border: "2px solid #f7f7f7ff",
              borderRadius: "9999px",
              backgroundColor: "transparent",
              color: "#92400e",
              fontWeight: "600",
              cursor: "pointer",
              transition: "0.3s",
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = "#fef3c7";
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = "transparent";
            }}
          >
            Load More Articles
          </button> */}
        </div>
      </section>

      {/* CTA SECTION */}
      <section
        style={{
          padding: "10px 20px",
          paddingBottom: "80px",
          backgroundColor: "black",
        }}
      >
        <div
          style={{
            maxWidth: "900px",
           
            margin: "0 auto",
            textAlign: "center",
            backgroundColor: "black",
            // padding: "40px",
            // borderRadius: "20px",
            // border: "1px solid whitesmoke",
            // boxShadow: "0 6px 16px rgba(0,0,0,0.1)",
            borderLeft: "8px solid #222121ff",
             color: 'whitesmoke',
      borderRadius: "8px",
    boxShadow: "0 4px 20px rgb(26 201 66 / 33%)",
  transition: "all 0.2s ease-in-out",
   padding: "40px",
          }}
        >
       
       <h2
  style={{
    fontSize: "32px",
    fontWeight: "700",
    marginBottom: "12px",
    color: "whitesmoke",
  }}
>
  Ready to Upgrade Your Power & Performance?
</h2>
<p
  style={{
    fontSize: "18px",
    color: "whitesmoke",
    marginBottom: "32px",
  }}
>
  Don’t just read about strength, stamina, and vitality—start experiencing
  balanced energy, better performance, and everyday confidence with BioSurge.
</p>

          <a
            href="/all-products"
            style={{
              display: "inline-block",
              padding: "14px 36px",
              backgroundColor: "whitesmoke",
              color: "black",
              borderRadius: "9999px",
              textDecoration: "none",
              fontWeight: "600",
              transition: "0.3s",
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = "#8b8683ff";
               e.target.style.color = "whitesmoke";
              
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = "whitesmoke";
               e.target.style.color = "black";
            }}
          >
           Start Your BioSurge Journey
          </a>
        </div>
      </section>
    </div>
  );
};

export default Blog;
